// Vendor
import { useI18n } from 'vue-i18n'

// Components
import HeaderComponent from '../../components/header/index';
import FooterComponent from '../../components/footer/index';
import ImageBoxComponent from '../../components/image-box/index';
import ModalComponent from '../../components/modal/index';
import DataRangeComponent from '../../components/date-range/index';
import ButtonComponent from '../../components/button/index';

export default {
    name: "classifica",
    components: {
        HeaderComponent,
        FooterComponent,
        ImageBoxComponent,
        ModalComponent,
        DataRangeComponent,
        ButtonComponent
    },
    data(){
        return {
            images: [
                {
                    "pid": "16849",
                    "imgPath": '2024/16849.png',
                    "selected": false
                },
                {
                    "pid": "155615",
                    "imgPath": '2024/155615.png',
                    "selected": false
                },
                {
                    "pid": "160394",
                    "imgPath": '2024/160394.png',
                    "selected": false
                },
                {
                    "pid": "198646",
                    "imgPath": '2024/198646.png',
                    "selected": false
                },
                {
                    "pid": "475683",
                    "imgPath": '2024/475683.png',
                    "selected": false
                },
                {
                    "pid": "8312",
                    "imgPath": '2024/8312.jpg',
                    "selected": false
                },
                {
                    "pid": "8405",
                    "imgPath": '2024/8405.jpg',
                    "selected": false
                },
                {
                    "pid": "8501",
                    "imgPath": '2024/8501.jpg',
                    "selected": false
                },
                {
                    "pid": "45659",
                    "imgPath": '2024/45659.jpg',
                    "selected": false
                },
                {
                    "pid": "163143",
                    "imgPath": '2024/163143.jpg',
                    "selected": false
                },
                {
                    "pid": "163144",
                    "imgPath": '2024/163144.jpg',
                    "selected": false
                },
                {
                    "pid": "163483",
                    "imgPath": '2024/163483.jpg',
                    "selected": false
                },
                {
                    "pid": "165201",
                    "imgPath": '2024/165201.jpg',
                    "selected": false
                },
                {
                    "pid": "168193",
                    "imgPath": '2024/168193.jpg',
                    "selected": false
                },
                {
                    "pid": "168197",
                    "imgPath": '2024/168197.jpg',
                    "selected": false
                },
                {
                    "pid": "190558",
                    "imgPath": '2024/190558.jpg',
                    "selected": false
                },
                {
                    "pid": "190566",
                    "imgPath": '2024/190566.jpg',
                    "selected": false
                },
                {
                    "pid": "198643",
                    "imgPath": '2024/198643.jpg',
                    "selected": false
                },
                {
                    "pid": "223752",
                    "imgPath": '2024/223752.jpg',
                    "selected": false
                },
                {
                    "pid": "550492",
                    "imgPath": '2024/550492.jpg',
                    "selected": false
                }
            ],
            currentPage: 1,
            maxImagesPerPage: 50,
            userLogged: false,
            userPrivacyProfiling: false,
            voted: false,
            pidVoted: '',
            vote_date: '',
            contestActive: false
        }
    },
    setup() {
        const { t } = useI18n({
            inheritLocale: true,
            useScope: 'local'
        })

        return { t }
    },
    computed:{
        /**
         * Filter images by current page and max images per page
         * @returns Array
         */
        paginatedImages() {
            let imagesUnshuffled = this.images;
            const imagesShuffled = imagesUnshuffled
                .map((value) => ({ value, sort: Math.random() }))
                .sort((a, b) => a.sort - b.sort)
                .map(({ value }) => value)
            return imagesShuffled.slice(0, this.currentPage * this.maxImagesPerPage);
        },

        /**
         * Check if there are another images or not
         * @returns {boolean}
         */
        numberTotal(){
            return (this.currentPage * this.maxImagesPerPage) < this.images.length
        }
    },
    methods:{
        // update page and load more images
        loadMore(){
            this.currentPage += 1;
        }
    }
}